function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "28.599",
  height: "17.99"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_298",
  "data-name": "Rectangle 298",
  fill: "#bebebe",
  d: "M0 0h28.599v17.99H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_671",
  "data-name": "Group 671"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_660",
  "data-name": "Group 660",
  clipPath: "url(#clip-path)",
  fill: "#bebebe"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_411",
  "data-name": "Path 411",
  d: "M12.829 17.99h-2.114a1.779 1.779 0 01-1.708-1.3L4.994 2.247A1.772 1.772 0 016.7 0h10.14a1.772 1.772 0 011.708 2.247l-4.011 14.444a1.78 1.78 0 01-1.708 1.3M6.7 1.505a.266.266 0 00-.257.339l4.015 14.446a.268.268 0 00.257.2h2.113a.269.269 0 00.257-.2L17.1 1.844a.26.26 0 00-.044-.233.265.265 0 00-.214-.105z",
  transform: "translate(2.49)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_412",
  "data-name": "Path 412",
  d: "M1.108 15.085a.753.753 0 010-1.505 5.2 5.2 0 100-10.4.753.753 0 010-1.505 6.706 6.706 0 110 13.412",
  transform: "translate(.179 .846)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_413",
  "data-name": "Path 413",
  d: "M.753 11.414a.753.753 0 010-1.505A2.453 2.453 0 10.753 5a.753.753 0 010-1.505 3.958 3.958 0 110 7.916",
  transform: "translate(0 1.768)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_414",
  "data-name": "Path 414",
  d: "M20.4 15.085a6.706 6.706 0 110-13.412.753.753 0 010 1.505 5.2 5.2 0 100 10.4.753.753 0 010 1.505",
  transform: "translate(6.917 .846)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_415",
  "data-name": "Path 415",
  d: "M19.828 11.414a3.958 3.958 0 010-7.916.753.753 0 010 1.505 2.453 2.453 0 000 4.906.753.753 0 010 1.505",
  transform: "translate(8.018 1.768)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_416",
  "data-name": "Path 416",
  d: "M10.112 10.944a1.9 1.9 0 111.9-1.9 1.9 1.9 0 01-1.9 1.9m0-2.289a.392.392 0 00-.391.393c0 .432.784.432.784 0a.393.393 0 00-.393-.393",
  transform: "translate(4.15 3.612)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_417",
  "data-name": "Path 417",
  d: "M10.419 7.3a2.813 2.813 0 112.813-2.813A2.816 2.816 0 0110.419 7.3m0-4.121a1.308 1.308 0 101.308 1.308 1.31 1.31 0 00-1.308-1.308",
  transform: "translate(3.843 .846)"
})))));